export default "<p>laprueba works!</p>\n";